// is a positive whole number
const isValidNumber = (num: number) =>
  typeof num === 'number' && Number.isInteger(num) && num >= 0;

export const timeInSecondsToSplitString = (time: number): string => {
  if (time === 0 || !isValidNumber(time)) return '00:00';
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = Math.floor((time % 3600) % 60);

  const hoursMinutesSeconds = [hours !== 0 ? hours : null, minutes, seconds];

  // Add 0-prefix to single-digit numbers if they are not in the first position of the timestring. Eg. 1:05 instead of 1:5
  return hoursMinutesSeconds
    .reduce<string[]>((acc: string[], num: number | null) => {
      if (num === null) return acc;
      const str = String(num);
      if (str.length === 1) {
        acc.push('0' + str);
        return acc;
      }
      acc.push(str);
      return acc;
    }, [])
    .join(':');
};

const SECONDS_PER_TIME = [1, 60, 3600];

export const timeSplitStringToTimeInSeconds = (
  timeString: string
): number | null => {
  // get last 3 numbers e.g. 11:22:33:44 => [22, 33, 44]
  const timeSplit = timeString.split(':').slice(-3).reverse();

  const timeArray = timeSplit.reduce<number[]>((acc, numStr, i) => {
    const timeStringAsNumber = Number(numStr);
    // do not include invalid numbers in resulting array
    if (isValidNumber(timeStringAsNumber)) {
      // convert to seconds
      // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
      acc.push(timeStringAsNumber * SECONDS_PER_TIME[i]);
    }
    return acc;
  }, []);

  // if any were not valid numbers
  if (timeArray.length !== timeSplit.length) return null;

  // sum all the seconds
  return timeArray.reduce((acc, num) => acc + num, 0);
};
